var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center mx-auto",staticStyle:{"height":"80vh","max-height":"80vh","max-width":"80vw"}},[_c('video',{ref:"player",staticClass:"mx-auto video-js vjs-default-skin vjs-big-play-centered"})])
}
var staticRenderFns = []

export { render, staticRenderFns }